import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment.prod';

export interface User {
  id?: string;
  name?: string;
  email?: string;
  role?: string;
  client_id?: string;
  client?: {
    id: string;
    name: string;
    contact_email: string;
    contact_phone: string;
    status: string;
  };
}

@Injectable({ providedIn: 'root' })
export class UserService {
  //private baseUrl = 'http://localhost:8001/users';
  private baseUrl = `${environment.apiBaseUrl}/api/users/`;

  constructor(private http: HttpClient, private auth: AuthService) {}

  getAll(): Observable<User[]> {
    return this.http.get<User[]>(this.baseUrl, this.auth.getAuthHeaders());
  }

  getByRole(role: string): Observable<User[]> {
    return this.http.get<User[]>(`${this.baseUrl}?role=${role}`, this.auth.getAuthHeaders());
  }

  getMe(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}me`, this.auth.getAuthHeaders());
  }

  create(user: Partial<User>): Observable<User> {
    return this.http.post<User>(this.baseUrl, user, this.auth.getAuthHeaders());
  }

  update(id: string, user: Partial<User>): Observable<User> {
    return this.http.put<User>(`${this.baseUrl}${id}`, user, this.auth.getAuthHeaders());
  }
}
